import { FC } from "react";
import { HStack, Text } from "@chakra-ui/react";

interface Props {
  title: string;
  amount: string;
}

export const DebtText: FC<Props> = ({ title, amount }) => {
  return (
    <HStack fontSize="12px" lineHeight="12px" justifyContent="space-between" pb="5px">
      <Text>{title}</Text>
      <Text>{amount}</Text>
    </HStack>
  );
};
